module.exports = __webpack_public_path__ + "static/media/ART_logo_footer.7d694612.png";